import { compose, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getBranchKey } from '../selectors';
import { getShopId } from '../../../../selectors';
import withExtensions from '../../../../extensions';


const withBranchKey = compose(
  withRouter,
  withExtensions,
  connect(
    (state, ownProps) => {
      const brandRoute = ownProps.params.brandRoute;
      const shopId = getShopId(state, ownProps.params.shopRoute);
      return {
        brandRoute,
        shopId,
        branchKey: getBranchKey(state, brandRoute, shopId),
      };
    },
  ),
  withPropsOnChange(
    ['brandRoute', 'shopId'],
    (props) => {
      const { brandRoute, shopId } = props;

      if (brandRoute || shopId) {
        props.fetchExtension(brandRoute || shopId);
      }
    },
  ),
);

export default withBranchKey;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/hoc/withBranchKey.js